import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 19 19",
	style: { enableBackground: "new 0 0 19 19" },
	xmlSpace: "preserve",
	fill: "#fbfbfb",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group_4543_00000156561776769795081210000008584309095994129080_",
		transform: "translate(-13935 -984)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Path_6864_00000018929140721829161270000002019101969291326904_",
			d: "M13950.4,987.7c-0.4-0.4-0.9-0.4-1.3,0 c0,0,0,0,0,0l-4.5,4.5l-4.5-4.5c-0.3-0.4-0.9-0.4-1.3-0.1c-0.4,0.3-0.4,0.9-0.1,1.3c0,0,0,0,0.1,0.1l4.5,4.5l-4.5,4.5 c-0.3,0.4-0.3,1,0,1.3c0.4,0.3,0.9,0.3,1.3,0l4.5-4.5l4.5,4.5c0.4,0.3,1,0.3,1.3-0.1c0.3-0.4,0.3-0.9,0-1.3l-4.5-4.5l4.5-4.5 C13950.7,988.6,13950.7,988,13950.4,987.7z"
		})
	})
});
export { SvgCloseIcon as ReactComponent };
